import Loadable from 'react-loadable'
import LoadingPage from 'views/LoadingPage'
import {DelayRender} from "../Discovery/DelayRender";
import React from "react";

const ChannelLazy = Loadable({
    loader: () => import('./Channel'),
    loading: LoadingPage
})

export const Channel = props => (
    <DelayRender>
        <ChannelLazy {...props} />
    </DelayRender>
)